import { serverlessRoutes } from "./constants";
import { deleteWithJwt, isNotFoundError } from "./requests";

const deleteExercisesByIds = async (ids: Array<number>) => {
  try {
    const { data } = await deleteWithJwt(serverlessRoutes.EXERCISE, { ids });

    return {
      ids: data?.ids || ids,
      alreadyDeleted: false,
    };
  } catch (error) {
    if (isNotFoundError(error)) {
      return {
        ids,
        alreadyDeleted: true,
      };
    }

    throw error;
  }
};

export { deleteExercisesByIds };
